// extracted by mini-css-extract-plugin
export var optionGrid = "_5t-7";
export var optionList = "_5t-6";
export var questionsBlock = "_5t-9";
export var spacer = "_5t-5";
export var stepCenteredContent = "_5t-3";
export var stepInner = "_5t-0";
export var stepInnerFullWidth = "_5t-1";
export var stepInnerLockScroll = "_5t-2";
export var stepTransitionFrame = "_5t-4";
export var welcomeBlock = "_5t-8";